var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CChartLine',{attrs:{"datasets":_vm.computedDatasets,"options":_vm.defaultOptions,"labels":_vm.computedLabels}})}
var staticRenderFns = []

export { render, staticRenderFns }